<template>
	<div class="mg-t-30 th">
		<div class="columns transition-2">
			<div class="column is-11 mg-x-auto">
				<div class="columns mg-0 pd-y-3 pd-x-3 is-flex-wrap border-filter transition-2" style="">
					<div  @click="getFocus()">
						<i class="fas fa-search"></i>
					</div>
					<div class="column is-10 pd-y-0 text" @click="getFocus()">
						<div class="new_taggings tag_edit" v-for="(item,index) in filterKey" :key="index">
							{{item}} <i @click="removeFilter('removeList',index)" class="fas fa-times cursor"></i>
						</div>
					</div>
					<div>
						<a v-if="this.filterKey.length > 0" class="clear_all_link" @click="removeFilter('removeAll',null)">Clear All</a>
					</div>
					<div class=" column is-10 transition-2" v-show="blurInput">
						<input @blur="blurInput = false" id="myAnchor" @keyup.enter="addValueFilter(keyword)" v-model="keyword" placeholder="Enter a keyword" class="keyword-input">
					</div>
				</div>
				<div class="columns filter mg-0 bg-grey-lighter pd-4">
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list" >
				            <button class="button" slot="trigger">
				                <span>Company</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<div v-show="companyListConst.length > 10" aria-role="listitem" class="has-text-centered auto-filter pd-y-1">
								<b-field class="mg-x-2">
									<b-input v-model="autoCompany"  @blur="clearAuto()" @keyup.native.enter="addValueFilter(autoCompany)" size="is-small" expanded></b-input>
								</b-field>
							</div>
				            <b-dropdown-item 
								v-for="(item,index) in companyListAuto"
								:key="index"
								@click="addValueFilter(item.organizationName)" 
								aria-role="listitem">{{item.organizationName}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list" class="dp-overfolw-auto">
				            <button class="button" slot="trigger">
				                <span>Categories</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<div aria-role="listitem" class="has-text-centered auto-filter pd-y-1">
								<b-field class="mg-x-2">
									<b-input v-model="autoCategories"  @blur="clearAuto()" @keyup.native.enter="addValueFilter(autoCategories)" size="is-small" expanded></b-input>
								</b-field>
							</div>
							<b-dropdown-item 
								v-for="(item,index) in businessTypeAuto"
								:key="index"
								@click="addValueFilter(item.name)" 
								aria-role="listitem">{{item.name}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list" >
				            <button class="button" slot="trigger">
				                <span>Business level</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<b-dropdown-item 
								v-for="(item,index) in businessLevel"
								:key="index"
								@click="addValueFilter(item.name)" 
								aria-role="listitem">{{item.name}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list" class="dp-overfolw-auto">
				            <button class="button" slot="trigger">
				                <span>Country</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<div aria-role="listitem" class="has-text-centered auto-filter pd-y-1">
								<b-field class="mg-x-2">
									<b-input v-model="autoCountry"  @blur="clearAuto()" @keyup.native.enter="addValueFilter(autoCountry)" size="is-small" expanded></b-input>
								</b-field>
							</div>
							<b-dropdown-item 
								v-for="(item,index) in dataCountryEN"
								:key="index"
								@click="addValueFilter(item.enName)" 
								aria-role="listitem">{{item.enName}}
							</b-dropdown-item>
							<!-- <b-dropdown-item 
								class="is-hidden-tablet"
								v-for="(item,index) in dataCountryEN"
								:key="index"
								@click="addValueFilter(item.enName)" 
								aria-role="listitem">{{item.enName}}
							</b-dropdown-item> -->
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list" class="dp-overfolw-auto">
				            <button class="button" slot="trigger">
				                <span>Province</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<div aria-role="listitem" class="has-text-centered auto-filter pd-y-1">
								<b-field class="mg-x-2">
									<b-input v-model="autoProvince"  @blur="clearAuto()" @keyup.native.enter="addValueFilter(autoProvince)" size="is-small" expanded></b-input>
								</b-field>
							</div>
							<b-dropdown-item 
								v-for="(item,index) in provinceFilter"
								:key="index"
								@click="addValueFilter(item.enName)" 
								aria-role="listitem">{{item.enName}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list">
				            <button class="button" slot="trigger">
				                <span>Employee</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<b-dropdown-item 
								v-for="(item,index) in employeeDynamic"
								:key="index"
								@click="addValueFilter(item.name)" 
								aria-role="listitem">{{item.name}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
					<div class="mg-1">
						<b-dropdown hoverable aria-role="list">
				            <button class="button" slot="trigger">
				                <span>Age group of customer</span>
				                <b-icon icon="menu-down"></b-icon>
				            </button>
							<b-dropdown-item 
								v-for="(item,index) in ageGroupCustomer"
								:key="index"
								@click="addValueFilter(item.name)" 
								aria-role="listitem">{{item.name}}
							</b-dropdown-item>
				        </b-dropdown>
					</div>
				</div>
			</div>
		</div>
		<div class="columns transition-2">
			<div class="column is-11 mg-x-auto">
				<b-table
					class="table-invest"
		            :data="companyListSortFollow"
		            :loading="isLoadingPage"
					:paginated="true"
					:per-page="10"
					:pagination-simple="false"
					aria-next-label="Next page"
					aria-previous-label="Previous page"
					aria-page-label="Page"
					aria-current-label="Current page"
					default-sort-direction="desc">
		            <template slot-scope="props">		
						<b-table-column field="follow" label=" "  centered :width="30" >
		                   <b-icon
						   		v-show="props.row.follow === 1"
								icon="heart"
								class="has-text-danger"
								size="is-success">
							</b-icon>
		                </b-table-column>
		                <b-table-column field="organizationName" label="Company"  sortable :width="300">
							<div class="is-flex is-align-center">
								<div class="profilePic  h-100 bd-shadow">
									<img v-if="typeof props.row.logo != 'undefined' && props.row.logo" :src="imgPath + props.row.logo">
									<img v-else src="@/assets/user.png">
								</div>
								<div class="fz-14 mg-x-3">
									<p>{{ props.row.organizationName}}</p>
								</div>
							</div>
		                </b-table-column>
						<b-table-column field="businessInformationEng" label="About" sortable :width="300">
		                    <p  v-if="props.row.categories !== '' && props.row.categories !== null" :title="props.row.businessInformationEng" class="fz-14">{{ props.row.businessInformationEng | snippetSmall}}</p>
							<p v-else class="fz-14">-</p>
		                </b-table-column>
		                <b-table-column field="categories" label="Categories" sortable :width="400">
		                    <p  v-if="props.row.categories !== '' && props.row.categories !== null" class="fz-14">{{ props.row.categories}}</p>
							<p v-else class="fz-14">-</p>
		                </b-table-column>
		                <b-table-column field="businessLevel" label="Business level" sortable centered :width="200">
		                    <p  v-if="props.row.businessLevel !== '' && props.row.businessLevel !== null" class="fz-14">{{ props.row.businessLevel}}</p>
							<p v-else class="fz-14">-</p>
		                </b-table-column>
		                <b-table-column field="country" label="Location" sortable centered>
		                    <p v-if="props.row.province !== '' && props.row.province !== null" class="fz-14">{{ props.row.province}}, {{props.row.country}}</p>
							<p v-else class="fz-14">-</p>
		                </b-table-column>
		                <b-table-column field="employee" label="Employee" sortable centered>
		                    <p v-if="props.row.employee !== '' && props.row.employee !== null" class="fz-14">{{ props.row.employee}}</p>
							<p v-else class="fz-14">-</p>
		                </b-table-column>
						<b-table-column  field="companyId" label=" " centered>
							<a @click="sentoDetailCompany(props.row)" class="fz-14 view-company">View</a>
		                </b-table-column>
		            </template>

					<template slot="empty">
						<section class="section">
							<div class="content has-text-grey has-text-centered">
								<p>
									<b-icon
										icon="emoticon-sad"
										size="is-large">
									</b-icon>
								</p>
								<p>{{(isLoadingPage)?'loading':'Not found data'}}</p>
							</div>
						</section>
					</template>
		        </b-table>
			</div>
		</div>
	</div>
</template>
<script>
import { HTTPIntegreat,HTTPDynamic } from "@/axios";

export default {
	data(){
		return{
			companyList: [],
			companyListConst:[],
			imgPath: process.env.VUE_APP_IMAGE_URL_INTEGREAT,
			blurInput:false,
			total: 0,
			isLoadingPage:false,
			keyword:'',
			filterKey:[],
			autoProvince:'',
			autoCountry:'',
			autoCategories:'',
			autoCompany:''
		}
	},
	computed: {
		companyListSortFollow(){
			return this.companyList.sort((a, b) => {
				const modifier = -1;
				if (a.follow < b.follow) return -1 * modifier;
				if (a.follow > b.follow) return 1 * modifier;
				return 0;
			});
		},
		idlogin(){
			return this.$store.state.idlogin
		},
		tokenForm(){
			return this.$store.state.tokenForm
		},
		businessLevel() {
			let businessLevel=[
				{id:1,name:'Formation (Ideating)'},
				{id:2,name:'Validation (Product/Market fit)'},
				{id:3,name:'Growth (Scaling)'}
			]
			return businessLevel;
		},
		businessTypeAuto() {
			let filter = []
			if (this.autoCategories !== '') {
				filter = this.$store.state.businessType.filter(item => item.name.toLowerCase().indexOf(this.autoCategories.toLowerCase()) > -1)
			}else{
				filter =  this.$store.state.businessType
			}
			return filter
		},
		businessType() {
			return this.$store.state.businessType
		},
		companyListAuto(){
			let filter = []
			if (this.autoCompany !== '') {
				filter = this.companyListConst.filter(item => item.organizationName.toLowerCase().indexOf(this.autoCompany.toLowerCase()) > -1)
			}else{
				filter =  this.companyListConst
			}
			return filter
		},
		dataCountryEN(){
			let filter = []
			if (this.autoCountry !== '') {
				filter = this.$store.state.country.filter(item => item.enName.toLowerCase().indexOf(this.autoCountry.toLowerCase()) > -1)
			}else{
				filter =  this.$store.state.country
			}
			return filter
		},
		dataCountry(){
			return this.$store.state.country
		},
		provinceFilter(){
			let filter = []
			if (this.autoProvince !== '') {
				filter = this.$store.state.province.filter(item => item.enName.toLowerCase().indexOf(this.autoProvince.toLowerCase()) > -1)
			}else{
				filter =  this.$store.state.province
			}
			return filter
		},
		provinceList(){
			return this.$store.state.province
		},
		employeeDynamic(){
			return this.$store.state.employeeDynamic
		},
		mentorInvest(){
			return this.$store.state.investMath
		},
		ageGroupCustomer(){
			let arr =[
				{id:1,name:'Lower than 14 years (Childhood)'},
				{id:2,name:'14- 24 years (Adolescent)'},
				{id:3,name:'25-40 years (Adulthood)'},
				{id:4,name:'41-60 years (Middle-aged)'},
				{id:5,name:'61-70 years (Retirement age)'},
				{id:6,name:'71+ years (Old-aged)'}
			]

			return arr
		}
	},
	mounted() {
		this.fetchCompanyAll()
	},
	methods:{
		async fetchCompanyAll(){
			this.isLoadingPage = true
			let secret = "15sD1F9EEA1Be115C85E00B35DCC1F86"
			let jwt = require('jsonwebtoken');
			let token = jwt.sign({ 
				idlogin:this.idlogin,
			}, secret);

			let data ={
				token:token
			}

			await HTTPIntegreat.post(`get/all/companies`,data)
			.then(async res => {
				this.companyList = []
				this.companyListConst = []
				if (res.data.success) {
					let company = res.data.obj
					for(let c in company) {
						for(let b in company[c].batchs) {
							let dataForm = await this.getDataForm(company[c].userId,company[c].batchs[b])
							if (dataForm.success) {
								let employee = (typeof dataForm.input.employeesInvestor !== 'undefined' && dataForm.input.employeesInvestor.data !== null)?dataForm.input.employeesInvestor.data.label:''
								let businessInformationEng = (typeof dataForm.input.businessInformationEng !== 'undefined')?dataForm.input.businessInformationEng:''
								let primaryTargetMarketEN = (typeof dataForm.input.primaryTargetMarketEN !== 'undefined')?dataForm.input.primaryTargetMarketEN:''
								let numberOfCustomers = (typeof dataForm.input.numberOfCustomers !== 'undefined')?dataForm.input.numberOfCustomers:''
								let serviceChargePerCustomers = (typeof dataForm.input.serviceChargePerCustomers !== 'undefined')?dataForm.input.serviceChargePerCustomers:''
								let ageCustomerMentor = (typeof dataForm.input.ageCustomerMentor !== 'undefined')?dataForm.input.ageCustomerMentor:[]
								let nameCorporateEn = (typeof dataForm.input.nameCorporateEn !== 'undefined')?dataForm.input.nameCorporateEn:(typeof dataForm.input.nameofCompanyProposal !== 'undefined')?dataForm.input.nameofCompanyProposal:''
								let nameExecutiveEn = (typeof dataForm.input.nameExecutiveEn !== 'undefined')?dataForm.input.nameExecutiveEn:(typeof dataForm.input.nameProposal !== 'undefined')?dataForm.input.nameProposal:''
								let lastNameExecutiveEn = (typeof dataForm.input.lastNameExecutiveEn !== 'undefined')?dataForm.input.lastNameExecutiveEn:(typeof dataForm.input.surnameProposal !== 'undefined')?dataForm.input.surnameProposal:''
								let businessLevelInvest = (typeof dataForm.input.businessLevelInvest !== 'undefined' && typeof dataForm.input.businessLevelInvest.data !== 'undefined' && dataForm.input.businessLevelInvest.data !== null)?dataForm.input.businessLevelInvest.data.label:''

								let teamArr = (typeof dataForm.inputCom['5cd29aa53fa34e30e056e47c1561812357233'] !== 'undefined')?dataForm.inputCom['5cd29aa53fa34e30e056e47c1561812357233']:[]
								let team  = this.getTeam(teamArr,dataForm.input,'5cd29aa53fa34e30e056e47c1561812357233')

								let tagetArr = (typeof dataForm.inputCom['5cd29aa53fa34e30e056e47c1562680149339'] !== 'undefined')?dataForm.inputCom['5cd29aa53fa34e30e056e47c1562680149339']:[]
								let taget  = this.getTaget(teamArr,dataForm.input,'5cd29aa53fa34e30e056e47c1562680149339')
								
								let otherArr = (typeof dataForm.inputCom['5cd29aa53fa34e30e056e47c1561816549340'] !== 'undefined')?dataForm.inputCom['5cd29aa53fa34e30e056e47c1561816549340']:[]
								let other  = this.getOther(otherArr,dataForm.input,'5cd29aa53fa34e30e056e47c1561816549340')
								
								
								let companyObj={
									companyId:company[c].userId,
									batch:company[c].batchs[b],
									logo:company[c].organizeLogo,
									organizationName:nameCorporateEn,
									categories:this.getCategory(company[c].category),
									follow:this.filterInvestMath(company[c].category),
									businessLevel:businessLevelInvest,
									province:this.getProvinceEN(company[c].province),
									country:this.getCountryEN(company[c].country),
									address:company[c].address,
									employee:employee,
									businessInformationEng:businessInformationEng,
									profilePic:company[c].profilePic,
									email:company[c].email,
									mobilePhone:company[c].mobilePhone,
									telephoneNumber:company[c].telephoneNumber,
									titleName:company[c].titleName,
									name:nameExecutiveEn,
									surname:lastNameExecutiveEn,
									bizGroup:company[c].bizGroup,
									bizModel:(company[c].bizModel === 1 )?'Production business':'Service business',
									bizType:company[c].bizType,
									cityDistrict:company[c].cityDistrict,
									position:company[c].position,
									postcode:company[c].postcode,
									subDistrict:company[c].subDistrict,
									websiteBusiness:company[c].websiteBusiness,
									websiteOfProduct:company[c].websiteOfProduct,
									primaryTargetMarketEN:primaryTargetMarketEN,
									numberOfCustomers:numberOfCustomers,
									serviceChargePerCustomers:serviceChargePerCustomers,
									ageCustomerMentor:ageCustomerMentor,
									team:team,
									other:other,
									taget:taget
								}
								
								this.companyList.push(companyObj)
								this.companyListConst.push(companyObj)
							}
						}
					}
					
				}else{
					this.companyList = []
				}
				this.isLoadingPage = false
			})
			.catch(e => {  
				console.log("get/all/companies/error",e);
			});
		},
		getTeam(data,input,key){
			let team = []

			let nameMember = (typeof input.nameMember !== 'undefined')?input.nameMember:''
			let englishNameTeam = (typeof input.englishNameTeam !== 'undefined')?input.englishNameTeam:''
			let positionMember = (typeof input.positionMember !== 'undefined')?input.positionMember:''
			let phoneNoMenber = (typeof input.phoneNoMenber !== 'undefined')?input.phoneNoMenber:''
			let linkedinTeam = (typeof input.linkedinTeam !== 'undefined')?input.linkedinTeam:''
			let profilePhotoTeam = (typeof input.profilePhotoTeam !== 'undefined')?input.profilePhotoTeam:''

			if (nameMember !== '') {
				team.push({
					nameMember:nameMember,
					englishNameTeam:englishNameTeam,
					positionMember:positionMember,
					phoneNoMenber:phoneNoMenber,
					linkedinTeam:linkedinTeam,
					profilePhotoTeam:profilePhotoTeam
				})
			}
			
			data.map((item,index)=>{

				let nameMember = (typeof input[key+'nameMember'+index] !== 'undefined')?input[key+'nameMember'+index]:''
				let englishNameTeam = (typeof input[key+'englishNameTeam'+index] !== 'undefined')?input[key+'englishNameTeam'+index]:''
				let positionMember = (typeof input[key+'positionMember'+index] !== 'undefined')?input[key+'positionMember'+index]:''
				let phoneNoMenber = (typeof input[key+'phoneNoMenber'+index] !== 'undefined')?input[key+'phoneNoMenber'+index]:''
				let linkedinTeam = (typeof input[key+'linkedinTeam'+index] !== 'undefined')?input[key+'linkedinTeam'+index]:''
				let profilePhotoTeam = (typeof input[key+'profilePhotoTeam'+index] !== 'undefined')?input[key+'profilePhotoTeam'+index]:''
	
				team.push({
					nameMember:nameMember,
					englishNameTeam:englishNameTeam,
					positionMember:positionMember,
					phoneNoMenber:phoneNoMenber,
					linkedinTeam:linkedinTeam,
					profilePhotoTeam:profilePhotoTeam
				})
			})

			
			return team
		},
		getTaget(data,input,key){
			let taget = []

			let primaryTargetMarketEN = (typeof input.englishNameTeam !== 'undefined')?input.primaryTargetMarketEN:''
			let numberOfCustomers = (typeof input.positionMember !== 'undefined')?input.numberOfCustomers:''
			let serviceChargePerCustomers = (typeof input.phoneNoMenber !== 'undefined')?input.serviceChargePerCustomers:''


			if (primaryTargetMarketEN !== '') {
				taget.push({
					primaryTargetMarketEN:primaryTargetMarketEN,
					numberOfCustomers:numberOfCustomers,
					serviceChargePerCustomers:serviceChargePerCustomers,
				})
			}
			
			data.map((item,index)=>{

				let primaryTargetMarketEN = (typeof input[key+'primaryTargetMarketEN'+index] !== 'undefined')?input[key+'primaryTargetMarketEN'+index]:''
				let numberOfCustomers = (typeof input[key+'numberOfCustomers'+index] !== 'undefined')?input[key+'numberOfCustomers'+index]:''
				let serviceChargePerCustomers = (typeof input[key+'serviceChargePerCustomers'+index] !== 'undefined')?input[key+'serviceChargePerCustomers'+index]:''

				taget.push({
					primaryTargetMarketEN:primaryTargetMarketEN,
					numberOfCustomers:numberOfCustomers,
					serviceChargePerCustomers:serviceChargePerCustomers
				})
			})

			
			return taget
		},
		getOther(data,input,key){
			let other = []

			let governmentInvesrtorInput = (typeof input.nameMember !== 'undefined')?input.governmentInvesrtorInput:''
			let departmentNameEng = (typeof input.englishNameTeam !== 'undefined')?input.departmentNameEng:''
			let logoDepartmentInvertor = (typeof input.positionMember !== 'undefined')?input.logoDepartmentInvertor:''

			if (governmentInvesrtorInput !== '') {
				other.push({
					governmentInvesrtorInput:governmentInvesrtorInput,
					departmentNameEng:departmentNameEng,
					logoDepartmentInvertor:logoDepartmentInvertor,
				})
			}
			
			data.map((item,index)=>{

				let governmentInvesrtorInput = (typeof input[key+'governmentInvesrtorInput'+index] !== 'undefined')?input[key+'governmentInvesrtorInput'+index]:''
				let departmentNameEng = (typeof input[key+'departmentNameEng'+index] !== 'undefined')?input[key+'departmentNameEng'+index]:''
				let logoDepartmentInvertor = (typeof input[key+'logoDepartmentInvertor'+index] !== 'undefined')?input[key+'logoDepartmentInvertor'+index]:''

				other.push({
					governmentInvesrtorInput:governmentInvesrtorInput,
					departmentNameEng:departmentNameEng,
					logoDepartmentInvertor:logoDepartmentInvertor
				})
			})

			
			return other

		},
		async getDataForm(id,batch){
			let data ={
				componentId:(typeof batch.formId !== 'undefined')?batch.formId:null,
				companyId:id,
				roleId:batch.batchId,
				keyRequest:this.tokenForm
			}
			let resObj = {}
			await HTTPDynamic.post(`get/data/form/prod`,data)
			.then(res => {
				
				if (res.data.success) {
					
					let dataInput = {}
					let dataCom = {}
                    if (new Date(res.data.obj.updateDate).getTime() < new Date('07/11/2019').getTime()) {
						dataInput =  this.covertInputData(res.data.obj.data)
						dataCom = {}
                    }else{
						dataInput = res.data.obj.data[0].input  
						dataCom = (typeof res.data.obj.data[0].inputForm !== 'undefined')?res.data.obj.data[0].inputForm:{}
					}

					let investorNationality = []
					if(typeof dataInput.investorNationality !== 'undefined'){
						investorNationality = dataInput.investorNationality.filter(filter => Number(filter.value) === 1)
					}
					
					if (typeof dataInput.presentToInvestors !== 'undefined' && dataInput.presentToInvestors.data !== null && dataInput.presentToInvestors.data.value === '1' && investorNationality.length > 0) {
						resObj =  {success:true,msg:'presentToInvestors true',input:dataInput,inputCom:dataCom}
					}else{
						resObj = {success:false,msg:'not presentToInvestors false',input:{},inputCom:{}}
					}
					
					
				}else{
					resObj = {success:false,msg:'not form data',input:{},inputCom:{}}
				}
			})
			.catch(e => {
				this.isLoadingPage=false;
				console.log("get/data/form/prod/error",e);
			});

			return resObj
		},
		covertInputData(data){  
			let obj ={}
			data.map((item)=>{
				obj = item.input
			})
			return obj
		},
		getLevelOfbusiness(id){
			console.log("getLevelOfbusiness",this.businessLevel,id)
			let businessLevel = this.businessLevel.filter(filter => filter.id === id)
			if (businessLevel.length > 0) {
				return businessLevel[0].name
			}else{
				return ''
			}
		},
		getCategory(id){
			let businessType = this.businessType.filter(filter => filter.id === id)
			if (businessType.length > 0) {
				return businessType[0].name
			}else{
				return ''
			}
		},
		getFocus(){
			this.blurInput = true
			setTimeout(() => {
				document.getElementById("myAnchor").focus();
			}, 500);
			
		},
		removeFilter(type,index){
			if(type == 'removeAll'){
				this.filterKey = []
				this.companyList = this.companyListConst
			}else{
				this.filterKey.splice(index, 1)
				this.filter()
			}
			
		},
		addValueFilter(value){
			this.filterKey.push(value)
			this.keyword = ''
			this.clearAuto()
			this.filter()
		},
		filter(){
			
			let companyArr = []
			this.companyListConst.map((company,index)=>{
				
				companyArr.push({data:company,num:[]})
				this.filterKey.map((search)=>{
					if (
						(typeof company.organizationName !== 'undefined' && company.organizationName !== null && company.organizationName.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.categories !== 'undefined' && company.categories !== null && company.categories.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.businessLevel !== 'undefined' && company.businessLevel !== null && company.businessLevel.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.province !== 'undefined' && company.province !== null && company.province.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.country !== 'undefined' && company.country !== null && company.country.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.employee !== 'undefined' && company.employee !== null && company.employee.toLowerCase().indexOf(search.toLowerCase()) > -1) ||
						(typeof company.businessInformationEng !== 'undefined' && company.businessInformationEng !== null && company.businessInformationEng.toLowerCase().indexOf(search.toLowerCase())) > -1 ||
						(typeof company.ageCustomerMentor !== 'undefined' && company.ageCustomerMentor !== null && company.ageCustomerMentor.length > 0 && this.checkArrFilter(company.ageCustomerMentor,search) === true)
					) {
						companyArr[index].num.push(1)
					}else{
						companyArr[index].num.push(0)
					}
				})
			})

			let companyAll = []
			companyArr.map((item)=>{
				if (Math.min(...item.num) > 0) {
					companyAll.push(item.data)
				}
			})
			this.companyList = companyAll
			
		},
		checkArrFilter(data,search){
			let filterArr = data.filter(filter => filter.label.toLowerCase().indexOf(search.toLowerCase()) > -1)

			if(filterArr.length > 0){
				return true
			}else{
				return false
			}
		},
		clearAuto(){
			setTimeout(() => {
				this.autoProvince = ''
				this.autoCountry = ''	
				this.autoCategories = ''
				this.autoCompany = ''
			}, 300);
		},
		sentoDetailCompany(company){
			this.$store.commit('setCompanyInvest',company)
			let routeData = this.$router.resolve({name: 'investCompany'});
			window.open(routeData.href, '_blank');
		},
		getCountryEN(input){
			let country = this.dataCountry.filter(item => item.name === input)
			if (country.length > 0) {
				return country[0].enName
			}else{
				return ''
			}
		},
		getProvinceEN(input){
			let country = this.provinceList.filter(item => item.name === input)
			if (country.length > 0) {
				return country[0].enName
			}else{
				return ''
			}
		},
		filterInvestMath(id){
			let name = this.getCategory(id)
			
			let filter = this.mentorInvest.filter(item=> item.label === name)
			if (filter.length > 0) {
				return 1
			}else{
				return 0
			}
		}
	}
}
</script>

<style scoped>
	.new_taggings.tag_edit {
	    background-color: #e0edf5;
	    border-radius: 3px;
	    color: #2f5d92;
	    float: left;
	    font-weight: 500;
	    height: 28px;
	    line-height: 28px;
	    margin: 0 8px 6px 0;
	    padding: 0 8px 0 8px;
	    white-space: nowrap;
	}
	.table-invest .table thead{
		background-color: #f8f9fa!important;
	}
	.data_entry {
	    border-top: 1px dashed #eee;
	    display: none;
	    margin-left: 22px;
	    margin-top: 10px;
	    padding: 12px 0 6px 6px;
	}
	.border-filter{
		border: 1px solid #e1e1e1;
		border-top-right-radius: 5px;
		border-top-left-radius: 5px;
	}
	.keyword-input {
	    border: none;
	    padding: 0;
	    width: 90%;
	}
	input.keyword-input:focus {
	    border: none;
	    box-shadow: none;
	    outline: unset;
	}
	.clear_all_link {
	    color: #aaa;
	    font-size: 12px;
	}
	.button:focus, .button.is-focused {
		border-color: #0FB9F4 !important;
		-webkit-box-shadow: 0 0 0 0.125em rgba(15, 185, 244, 0.25) !important;
	}
	.table td, .table th {
		vertical-align: inherit!important;
	}
	.fz-14{
		font-size: 14px!important;
	}
	.view-company{
		color:#0FB9F4 !important;
	}
	.view-company:hover{
		color:#363636 !important;
	}
	
</style>